import * as React from "react";

function SvgLink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M8.79 19l-1.22 1.25a2.72 2.72 0 01-3.81 0 2.63 2.63 0 010-3.76l4.47-4.43c.92-.92 2.66-2.28 3.94-1a1.485 1.485 0 102.09-2.11C12.1 6.79 8.91 7.19 6.13 10l-4.47 4.38a5.61 5.61 0 000 8 5.69 5.69 0 008 0l1.22-1.2A1.51 1.51 0 008.79 19zM22.34 1.81C20-.49 16.77-.61 14.63 1.52L13.11 3a1.49 1.49 0 002.1 2.11l1.51-1.5c1.11-1.11 2.57-.65 3.52.29a2.63 2.63 0 010 3.76l-4.77 4.73c-2.18 2.16-3.2 1.15-3.64.71a1.485 1.485 0 10-2.09 2.11 4.66 4.66 0 003.34 1.49 6.55 6.55 0 004.49-2.2l4.77-4.73a5.63 5.63 0 000-8z" />
    </svg>
  );
}

const MemoSvgLink = React.memo(SvgLink);
export default MemoSvgLink;
